import { global_hooks } from 'src/globals';

global_hooks.on('after_init', init);

function init() {
	document.querySelectorAll('.button_arrows').forEach(arrows => {
		const container = arrows.closest('.e-con-inner');
		if (!container) return;

		const carousel_arrows = container.querySelector('.carousel_arrows');
		if (carousel_arrows) carousel_arrows.style.display = 'none';

		const carousel_prev = carousel_arrows?.querySelector('.prev');
		const carousel_next = carousel_arrows?.querySelector('.next');

		arrows.querySelector('.prev')?.addEventListener('click', () => carousel_prev?.click());
		arrows.querySelector('.next')?.addEventListener('click', () => carousel_next?.click());
	});
}
